import axios from "axios";
import Cookies from "js-cookie";
import { API_HOST } from "@/_constant";

const api = axios.create({
  baseURL: API_HOST
});


api.interceptors.request.use((config)=> {
  if(typeof config.headers["Content-Type"] === 'undefined' || typeof config.headers["Content-Type"] === ''){
    config.headers['Content-Type'] = 'application/json';
  }
  if(typeof config.headers.Accept === 'undefined' || typeof config.headers.Accept === ''){
    config.headers.Accept = 'application/json';
  }
  const token = Cookies.get('token');

  if(token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => Promise.reject(error)); 

api.interceptors.response.use(
  (response) => response, 
  (error) => {
    const {response} = error;
    if(!response){
      return Promise.reject(error);
    }

    if(response.status === 401){
      //show login popup
    } else if (response.status === 403){
      //show fallback page
    }
  return Promise.reject(error);
});

export default api;